import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { API, fmtErr } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    API.post("/auth/google/session", { session_id: sessionId })
      .then((r) => {
        setUser(r.data);
        navigate("/dashboard", { replace: true, state: { user: r.data } });
      })
      .catch((e) => {
        toast.error(fmtErr(e));
        navigate("/login", { replace: true });
      });
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background" data-testid="auth-callback-loading">
      <div className="flex flex-col items-center gap-3">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
        <p className="text-sm text-muted-foreground">Signing you in…</p>
      </div>
    </div>
  );
}
